<template>
  <VcConfirmModal
    class="session-timeout-modal"
    :showCloseButton="false"
    showDialog
    :title="$t('session_timout.title')"
    :contentText="$t('session_timout.content')"
    useOffset
    size="md"
    :okButtonLabel="$t('session_timout.keep_me_logged_in')"
    @onOkClicked="handleExtendSession"
    @onCancelClicked="handleLogout"
    :cancelButtonLabel="$t('session_timout.logout')"
    dataQa="session-timeout-modal"
  >
  <template #content>
    <div>
      <div class="mb-5">{{ $t('session_timout.content') }}</div>
      <div class="time-left-label">{{ $t('session_timout.time_left') }}</div>
      <div class="time-left-value">{{ formattedTimeRemaining }}</div>
    </div>
    </template>
  </VcConfirmModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SessionTimoutPromptContainer',
  data() {
    return {
      timeRemaining: 0,
      countdownInterval: null,
    };
  },
  computed: {
    ...mapGetters('AuthStore', ['sessionExpiration']),
    formattedTimeRemaining() {
      const minutes = Math.floor(this.timeRemaining / 60);
      const seconds = this.timeRemaining % 60;
      const formattedSeconds = seconds.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');
      return `${formattedMinutes}:${formattedSeconds}`;
    },
  },
  created() {
    this.addI18nModule('session-timeout-pov');
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  methods: {
    ...mapActions('AuthStore', ['extendSession', 'onLogout']),
    timestampInSec() {
      return Math.floor(Date.now() / 1000);
    },
    startCountdown() {
      this.updateTimeRemaining();
      this.countdownInterval = setInterval(() => {
        this.updateTimeRemaining();
        if (this.timeRemaining <= 0) {
          this.stopCountdown();
          this.onLogout();
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
    updateTimeRemaining() {
      const remaining = this.sessionExpiration - this.timestampInSec();
      this.timeRemaining = Math.max(0, remaining);
    },
    async handleExtendSession() {
      this.stopCountdown();
      await this.extendSession();
    },
    async handleLogout() {
      this.stopCountdown();
      await this.onLogout();
    },
  },
};
</script>
<style lang="scss" scoped>
.time-left-label {
  font-size:  var(--font-size-x-small);
  font-weight: var(--font-weight-large);
  color: var(--gray-darken-5);
}
.time-left-value {
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-large2);
  color: var(--gray-darken-5);
}
</style>
